module.exports = __webpack_public_path__ + "img/isotipo.de7089d3.svg";